import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { useBranchOfficeEditDialog } from '../../../hooks/useDialog'
import useYup from '../../../hooks/useYup'
import useValidationRule from '../../../hooks/useValidationRule'
import { CompanyActions } from '../../../store/company'
import Dialog from '../../atoms/feedback/Dialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import FormItem from '../../molecules/inputs/FormItem'
import TextField from '../../atoms/inputs/TextField'

type Params = {
  name: string
}

export default function BranchOfficeEditDialog() {
  const { state, close } = useBranchOfficeEditDialog()
  const dispatch = useDispatch()
  const yup = useYup()
  const rules = useValidationRule()
  const schema = yup.object().shape({
    name: rules.branchOfficeName.required(),
  })
  const form = useForm<Params>({
    resolver: yupResolver(schema),
    defaultValues: {
      name: state?.branchOffice.name,
    },
  })
  const errors = form.formState?.errors

  const handleUpdate = useCallback(
    (params: Params) => {
      if (state?.branchOffice) {
        dispatch(CompanyActions.updateBranchOffice({ branchOfficeId: state.branchOffice.id, name: params.name }))
      }
    },
    [dispatch, state?.branchOffice]
  )

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="支店編集"
      onSubmit={form.handleSubmit(handleUpdate)}
      actions={
        <FlexRow>
          <Button type="submit">保存</Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <FormItem label="支店名">
          <TextField register={form.register('name')} error={errors.name?.message} />
        </FormItem>
      </FlexColumn>
    </Dialog>
  )
}
